import React from "react";
import { Layout, Empty, Row, Col, Result } from "antd";
import LayoutHeader from "./layout_header";
// redux

const { Content } = Layout;
const AllowScreen = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title="Dịch Vụ Chuyển Âm" />
      <Content className="content">
        <Row gutter={[10, 10]}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Result
              status="403"
              title="Not Authorized"
              subTitle="Rất tiếc ! Bạn chưa có quyền truy cập vào Dịch Vụ Chuyển Âm, Xin vui lòng liên hệ quản trị viên để cấp quyền."
            />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default AllowScreen;
